module.exports = __webpack_public_path__ + "static/media/twitter.ec9aec3f.svg";